
export const breakpoints = {
    mobile: "576px",
    tablet: "768px",
    laptop: "992px",
    desktop: "1200px",
    wideScreen: "1400px"
}